export function blobUrl(cdn: URL | undefined, did: string, cid: string): string | undefined {
  if (!cdn) return undefined;
  const url = new URL(cdn.href.endsWith("/") ? cdn.href : `${cdn.href}/`);
  url.pathname += `${did}/${cid}`;
  return url.href;
}
